import { z } from 'zod';

export const backfillVaultPathResponseSchema = z.object({
  total: z.number(),
  updated: z.number(),
  skipped: z.number(),
});

export type IBackfillVaultPathResponse = z.infer<typeof backfillVaultPathResponseSchema>;
